window.addEventListener('load', function() {

	/**
	 * Adds a class `_submit-attempted` to a form when it's attempted to be
	 * submitted.
	 *
	 * This allows us to style invalid form fields differently for forms that
	 * have and haven't been attemted to submit.
	 */
	function addFormSubmitAttemptedTriggers() {
		var formEls = document.querySelectorAll('form');

		for (var i = 0; i < formEls.length; i++) {
			function addSubmitAttemptedTrigger(formEl) {
				var submitButtonEl = formEl.querySelector('input[type=submit], button[type=submit]');

				if (submitButtonEl) {
					submitButtonEl.addEventListener('click', function() {
						formEl.classList.add('_submit-attempted');
					});
				}
			}

			addSubmitAttemptedTrigger(formEls[i]);
		}
	}

	addFormSubmitAttemptedTriggers();

});
